import { IconButton, Badge, Menu } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import Iconify from "../components/Iconify";
import { messagesUnread } from "../core/redux/features/messeages/messeagesSlice";
import { useAppDispatch, useAppSelector } from "../core/redux/hooks";
import { fetchMessagesUnread } from "../core/redux/features/messeages/messeagesThunks";
import {
  fetchUserNotifications,
  selectAllUserNotifications,
  selectAllUserNotificationStatus,
} from "../core/redux/features/users/userSlice";

type Props = {
  children: React.ReactNode;
};

const CustomPopover = (props: Props) => {
  const anchorRef = useRef(null);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { status, count } = useAppSelector(messagesUnread);
  const notifications = useAppSelector(selectAllUserNotifications);
  const notificationStatus = useAppSelector(selectAllUserNotificationStatus);

  const dispatch = useAppDispatch();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (status === "idle")
      dispatch(fetchMessagesUnread({ limit: 12, skip: 0 }));
  }, []);

  useEffect(() => {
    if (notificationStatus === "idle") dispatch(fetchUserNotifications());
  }, []);

  return (
    <>
      <IconButton
        ref={anchorRef}
        color={open ? "primary" : "default"}
        onClick={handleClick}
        sx={{ width: 40, height: 40 }}
      >
        <Badge
          badgeContent={
            count + notifications.filter((item) => !item.isReadBy).length
          }
          color="error"
        >
          <Iconify icon="eva:bell-fill" width={20} height={20} />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        // sx={{ maxWidth: { xs: 300, md: 400, lg: 500 } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {props.children}
      </Menu>
    </>
  );
};

export default CustomPopover;
